/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'able': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 896a384 384 0 100-768 384 384 0 000 768zm0 128A512 512 0 11512 0a512 512 0 010 1024z"/><path pid="1" d="M468.48 568.064l211.627-282.197 102.4 76.8L482.304 763.05l-222.89-222.976 90.453-90.368z"/>'
  }
})
